import { Controller } from 'stimulus';

const csrfParamSelector = "head meta[name='csrf-param']";
const csrfTokenSelector = "head meta[name='csrf-token']";
const defaultErrorClass = 'o-form-field--error';
const defaultHiddenClass = 'u-is-hidden';

const trimValue = input => {
  input.value = input.value.trim();
};

export default class extends Controller {
  static targets = ['errorMessage', 'input', 'child'];

  connect() {
    this._csrfParam = document.querySelector(csrfParamSelector).content;
    this._csrfToken = document.querySelector(csrfTokenSelector).content;
    this._errorClass = this.data.get('error-class') || defaultErrorClass;
    this._hiddenClass = this.data.get('hidden-class') || defaultHiddenClass;

    this._updateUrl = [
      this.element.closest('form').action,
      'form_fields',
      this.data.get('id'),
    ].join('/');
  }

  update(event) {
    trimValue(event.target);

    if (!this._shouldAttemptUpdate()) {
      return;
    }

    this._clearErrors();

    if (this._inputsAreValid()) {
      this._update(this._inputValue(event.target));
    } else {
      this._showErrors(this.inputTarget.validationMessage);
    }
  }

  _clearErrors() {
    this.element.classList.remove(this._errorClass);
    this.hasErrorMessageTarget && this.errorMessageTarget.remove();
  }

  _dateParts() {
    if (!this.inputTarget.dataset.dateField) {
      return [];
    }

    const day = this.inputTargets.find(t => t.name.match(/\[day\]/)).value;
    const month = this.inputTargets.find(t => t.name.match(/\[month\]/)).value;
    const year = this.inputTargets.find(t => t.name.match(/\[year\]/)).value;

    return { year, month, day };
  }

  _inputsAreValid() {
    return this.inputTargets.every(input => input.validity.valid);
  }

  _inputValue(changedInput) {
    if (this.inputTarget.dataset.dateField) {
      const { year, month, day } = this._dateParts();
      return `${year}-${month}-${day}`;
    } else if (this.inputTarget.type === 'checkbox') {
      return this.inputTargets
        .filter(input => input.checked)
        .map(input => input.value);
    } else {
      return this.inputTargets.find(input => input.id === changedInput.id)
        .value;
    }
  }

  _showErrors(errorMessage) {
    this.element.classList.add(this._errorClass);
    this.element.insertAdjacentHTML(
      'beforeend',
      `<p class="error-message" data-target="field.errorMessage">
        ${errorMessage}
      </p>`
    );
  }

  async _update(value) {
    const body = JSON.stringify({
      form_value: { value },
      [this._csrfParam]: this._csrfToken,
    });

    await fetch(this._updateUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body,
    })
      .then(response => response.text())
      .then(html => {
        const fragment = document.createRange().createContextualFragment(html);
        this.element.parentNode.replaceChild(fragment, this.element);
      });
  }

  // No point in trying to update date fields until we have day, month, and year
  _shouldAttemptUpdate() {
    if (!this.inputTarget.dataset.dateField) {
      return true;
    }

    return this.inputTargets.every(select => select.value !== '');
  }
}
